<template>
  <div class="product-menu">
    <div class="menu-columns">
    <div class="all-products-column">
      <router-link :to="productsRoute" @click.native="$emit('navigate')">All Products</router-link>
    </div>
    <div class="categories-column">
    <section v-for="group in groups" :key="group.key">
      <h3 class="category-heading">{{ group.label }}</h3>
      <div class="category-links">
        <router-link v-for="entry in group.entries" :key="entry.id" :to="entry.to" @click.native="$emit('navigate')">
          {{ entry.label }}
        </router-link>
      </div>
    </section>
    </div>
    </div>
  </div>
</template>

<script>
import { productCategoryRoute } from '@/utils/productCategoryRoute'

export default {
  name: 'ProductMenu',
  props: { categories: { type: Array, default: () => [] } },
  computed: {
    productsRoute() {
      return { path: `/${this.$route.params.lang || this.$store.state.user.lang || 'en'}/products` }
    },
    groups() {
      const visible = items => (items || []).filter(item => Number(item.categoryState) === 1)
      const roots = visible(this.categories)
      const entries = root => visible(root && root.children).map(item => ({
        id: item.id,
        label: item.categoryName,
        to: productCategoryRoute(item, root, this.productsRoute.path)
      }))
      // All enabled root categories are peers; each owns only its direct children.
      return roots.map(root => ({ key: root.id, label: root.categoryName, entries: entries(root) }))
    }
  }
}
</script>

<style scoped>
.product-menu { width: 100%; padding: 24px; box-sizing: border-box; text-align: left; color: #fff; background: #232323; }
.menu-columns { display: grid; grid-template-columns: 180px minmax(0, 1fr); gap: 48px; max-width: 1200px; margin: 0 auto; align-items: start; }
.all-products-column { min-width: 0; }
.categories-column { min-width: 0; display: grid; gap: 20px; }
.category-heading { margin: 0; padding: 10px 0; font-size: 14px; line-height: 1.5; font-weight: 600; }
.product-menu a, .product-menu button { display: flex; align-items: center; justify-content: space-between; width: 100%; padding: 10px 0; border: 0; background: none; color: inherit; font: inherit; font-size: 14px; line-height: 1.5; text-align: left; text-decoration: none; cursor: pointer; }
.product-menu a:hover, .product-menu button:hover { text-decoration: underline; text-underline-offset: 5px; }
.product-menu a:focus-visible, .product-menu button:focus-visible { outline: 1px solid currentColor; outline-offset: 3px; }
.product-menu button span { margin-left: 16px; color: #aaa; }
.category-links { display: flex; flex-wrap: wrap; gap: 0 28px; padding-left: 16px; border-left: 1px solid #666; }
.category-links a { width: auto; max-width: 100%; min-height: 44px; box-sizing: border-box; overflow-wrap: anywhere; font-size: 13px; color: #ddd; }
.empty { display: block; padding: 8px 0; font-size: 13px; color: #aaa; }
@media (min-width: 1025px) {
  .all-products-column { padding-left: 80px; }
}
@media (max-width: 1024px) {
  .product-menu { padding: 12px 18px; }
  .menu-columns { grid-template-columns: minmax(0, 1fr) minmax(0, 1.5fr); gap: 16px; }
}
</style>
